import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchForeignSystems } from 'common/services/api/ForeignSystems/ForeignSystems.thunk';
import { ForeignSystem, UserForeignKey } from 'common/types/Entities';
import { groupBy } from 'common/utils/GroupBy';

import type { RootState } from '../../app/store';

type UserProfileForeignSystemsSliceState = {
    userProfileForeignKeys: UserForeignKey[];
    foreignSystems: ForeignSystem[];
};

const initialState: UserProfileForeignSystemsSliceState = {
    userProfileForeignKeys: [],
    foreignSystems: [],
};

const userProfileForeignSystemSlice = createSlice({
    name: 'userProfileForeignSystem',
    initialState,

    reducers: (create) => ({
        setUserProfileForeignKeys: create.reducer((state, action: PayloadAction<UserForeignKey[]>) => {
            state.userProfileForeignKeys = action.payload;
        })
    }),

    extraReducers: builder => {
        builder.addCase(fetchForeignSystems.pending, state => {
            state.foreignSystems = [];
        });
        builder.addCase(fetchForeignSystems.fulfilled, (state, action: PayloadAction<ForeignSystem[]>) => {
            state.foreignSystems = action.payload;
        });
        builder.addCase(fetchForeignSystems.rejected, state => {
            state.foreignSystems = [];
        });
    }
});

// eslint-disable-next-line no-restricted-syntax
export default userProfileForeignSystemSlice.reducer;
export const { setUserProfileForeignKeys } = userProfileForeignSystemSlice.actions;
export const selectForeignSystems = (state: RootState) => state.userProfileForeignSystem.foreignSystems;
export const selectUserForeignKeysList = (state: RootState) => state.userProfileForeignSystem.userProfileForeignKeys;
export const selectUserForeignKeysGroupedByName = createSelector(
    [selectUserForeignKeysList],
    (userForeignKeys) => groupBy<UserForeignKey>(userForeignKeys, 'foreignSystemName')
);
